'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('tvs_motors_ld_benchmark', {
      url: '/tvs_motors_ld_benchmark',
      template: '<tvsmotorsldbenchmarktab></tvsmotorsldbenchmarktab>',
      authenticate: 'admin'
    });
}
